/// <reference types="@angular/localize" />
import { ASSETS_HTTP_CLIENT } from './app/app.module';
import { fetchConfig, provideConfig } from './config/config';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { IsoDateAdapter } from './app/iso-date-adapter.service';
import { importProvidersFrom, Injector, LOCALE_ID } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { Menu } from '@shared/services/menu.service';
import { SitesService } from '@shared/services/sites/sites.service';
import { LogsService } from '@shared/services/logs/logs.service';
import { Graph } from '@shared/components/highcharts/graph/graph';
import { Bar } from '@shared/components/highcharts/bar-horizontal/bar';
import { Donut } from '@shared/components/highcharts/donut/donut';
import { ApiInterceptor } from '@shared/api-interceptor';
import { LoaderInterceptorService } from '@shared/services/loader-interceptor.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { VERSION } from 'config/version';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { ToastrModule } from 'ngx-toastr';
import { HighchartsChartModule } from 'highcharts-angular';
import { CodeInputModule } from 'angular-code-input';
import { AdminModule } from './app/theme/admin/admin.module';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { AppComponent } from './app/app.component';

(async function () {
  const config = await fetchConfig();
  if (config.silentConsole && window) {
    window.console.log = window.console.warn = window.console.info = function () {};
  }

  bootstrapApplication(AppComponent, {
    providers: [
      provideConfig(config),
      importProvidersFrom(
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        NgxPaginationModule,
        NgSelectModule,
        NgxDatatableModule,
        ToastrModule.forRoot({
          timeOut: 8000,
          positionClass: 'toast-bottom-right',
          maxOpened: 3,
          progressBar: true,
        }),
        HighchartsChartModule,
        CodeInputModule,
        AdminModule,
        CdkDrag,
        CdkDropList,
      ),
      { provide: NgbDateAdapter, useClass: IsoDateAdapter },
      {
        provide: LOCALE_ID,
        deps: [AuthService],
        useFactory: (auth: AuthService) => auth.getCurrentLanguage(),
      },
      {
        provide: ASSETS_HTTP_CLIENT,
        deps: [HttpBackend],
        useFactory: (httpBackend: HttpBackend) => new HttpClient(httpBackend),
      },
      Menu,
      AuthService,
      SitesService,
      LogsService,
      Graph,
      Bar,
      Donut,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: LoaderInterceptorService,
        multi: true,
      },
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (injector: Injector) =>
            new TranslateHttpLoader(injector.get(ASSETS_HTTP_CLIENT), '/assets/i18n/', `.json?version=${VERSION}`), // never cached,
          deps: [Injector],
        },
      }).providers!,
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
    ],
  }).catch((err) => console.log(err));
})();
